import React from 'react'
import Billboard from "../../components/Billboard";
import Links from "./Links/Links";
import autoplay from "swiper/src/components/autoplay/autoplay";
import MarkdownContent from "./MarkdownContent";

const Quote = ({text, author}) => {
    return (
        <div className="CaseStudy-BlueQuote">
            <blockquote>
                {text}
                <p>
                    {author}
                </p>
            </blockquote>
        </div>
    )
}


const Industry = ({name}) => {
    if(!name) return null
    return (
        <div className="col-6">
            <div className="row">
                <div className="col-4 CaseStudy__faIcon">
                    <i className="fas fa-hand-holding-heart"></i>
                </div>
                <div className="col-8">
                    <div className="CaseStudy__subtitle">Industry</div>
                    <div>{name}</div>
                </div>
            </div>
        </div>
    )
}
const Location = ({name}) => {
    if(!name) return null
    return (
        <div className="col-6">
            <div className="row">
                <div className="col-4 CaseStudy__faIcon">
                    <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="col-8">
                    <div className="CaseStudy__subtitle">Location</div>
                    <div>{name}</div>
                </div>
            </div>
        </div>
    )
}



const TemplateDefaultWithQuotes = ({frontmatter, html, fields}) => {
    const companyLogoUrl = fields.companyLogo ? fields.companyLogo.publicURL : undefined
    const qutes = frontmatter.quotes.map((quote) => {
        return (
            <Quote text={quote.text} author={quote.author} />
        )
    })

    return (
        <>
            <Billboard className="Billboard--resources" color="white">
                <div className="Billboard__top">
                    <h1 className="Billboard__title">{frontmatter.title}</h1>
                    <div className="Billboard__lead">CASE STUDY</div>
                    <div className="Billboard__cta" />
                </div>
            </Billboard>

            <div className="CaseStudy">

                <section className="section blogWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9">
                                <div className="row CaseStudy--twoColumns">
                                    <div className="col-md-5">
                                        <img src={companyLogoUrl} alt={frontmatter.company.name} className="img-thumbnail" />
                                        <div className="CaseStudy--blueColumn">
                                            {qutes}
                                        </div>
                                    </div>
                                    <div className="col-md-7 CaseStudy--rightColumnContainer">
                                        <h2>
                                            The Client
                                        </h2>
                                        <h3>
                                            {frontmatter.company.name}
                                        </h3>
                                        <div className="row">
                                            <Industry name={frontmatter.company.industry}/>
                                            <Location name={frontmatter.company.location}/>
                                        </div>
                                        <div className="row">
                                           <div className="col-md-12 CaseStudy--companyDescription">
                                               <MarkdownContent content={frontmatter.company.description} className=""/>
                                           </div>
                                        </div>
                                    </div>
                                </div>
                                <article className="article">
                                    <div
                                        className="CaseStudy--html"
                                        dangerouslySetInnerHTML={{ __html: html }}
                                    />
                                </article>
                            </div>

                            <div className="col-md-3">
                                <div className="blogSidebar">
                                    <Links/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>


        </>
    )

}

export default TemplateDefaultWithQuotes

